"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.monotonicNow = exports.monotonicDiff = exports.curTimestamp = exports.calcTimestampDelta = exports.applyTimestampDeltaInMicroseconds = exports.applyTimestampDelta = void 0;
var monotonicNow = exports.monotonicNow = function monotonicNow() {
  if (typeof window !== 'undefined' && window.performance) {
    return window.performance.now();
  }
  return _curTimestampInMicroSeconds();
};
var curTimestamp = exports.curTimestamp = function curTimestamp() {
  return _toString(_curTimestampInMicroSeconds());
};
var monotonicDiff = exports.monotonicDiff = function monotonicDiff(monotonicTime) {
  return Math.round(monotonicNow() - monotonicTime);
};
var calcTimestampDelta = exports.calcTimestampDelta = function calcTimestampDelta(serverTimestampInSeconds) {
  return _curTimestampInMicroSeconds() - _secondsToMicroseconds(serverTimestampInSeconds);
};
var applyTimestampDelta = exports.applyTimestampDelta = function applyTimestampDelta(date) {
  var deltaInMicroseconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (!date) return date;
  var timestamp = _millisecondsToMicroseconds(new Date(date).getTime());
  var timestampWithDelta = timestamp + _toInt(deltaInMicroseconds);
  return new Date(_microsecondsToMilliseconds(timestampWithDelta)).toISOString();
};
var applyTimestampDeltaInMicroseconds = exports.applyTimestampDeltaInMicroseconds = function applyTimestampDeltaInMicroseconds(timestamp) {
  var deltaInMicroseconds = arguments.length > 1 && arguments[1] !== undefined ? arguments[1] : 0;
  if (!timestamp) return timestamp;
  var timestampWithDelta = _toInt(timestamp) + _toInt(deltaInMicroseconds);
  return _toString(timestampWithDelta);
};
var _toInt = function _toInt(value) {
  return parseInt(value, 10);
};
var _toString = function _toString(value) {
  return "".concat(value);
};
var _secondsToMicroseconds = function _secondsToMicroseconds(seconds) {
  return _toInt(seconds) * 1000000;
};
var _millisecondsToMicroseconds = function _millisecondsToMicroseconds(milliSeconds) {
  return _toInt(milliSeconds) * 1000;
};
var _microsecondsToMilliseconds = function _microsecondsToMilliseconds(microSeconds) {
  return _toInt(microSeconds) / 1000;
};
var _curTimestampInMicroSeconds = function _curTimestampInMicroSeconds() {
  return _millisecondsToMicroseconds(new Date().getTime());
};